module.exports = __webpack_public_path__ + "img/video-y-fotografia-subacuatica_info.80e70da9.jpg";